if (!customElements.get('bundle-builder')) {
  customElements.define(
    'bundle-builder',
    class BundleBuilder extends HTMLElement {
      constructor() {
        super();

        this.minItems = parseInt(this.dataset.minItems, 10) || 1;
        this.incentiveText = this.dataset.incentiveText || '';
        this.unlockedText = this.dataset.unlockedText || '';
        this.addUrl = this.dataset.addUrl;

        this.checkboxes = Array.from(this.querySelectorAll('.bundle-builder__checkbox'));
        this.progressEl = this.querySelector('[data-bundle-progress]');
        this.submitButton = this.querySelector('[data-bundle-submit]');

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.checkboxes.forEach((checkbox) => {
          checkbox.addEventListener('change', this.updateState.bind(this));
        });

        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmit.bind(this));
        }

        this.updateState();
      }

      get selectedVariantIds() {
        return this.checkboxes.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.dataset.variantId);
      }

      updateState() {
        const selectedCount = this.selectedVariantIds.length;

        if (this.progressEl) {
          if (selectedCount >= this.minItems) {
            this.progressEl.textContent = this.unlockedText;
          } else {
            const remaining = this.minItems - selectedCount;
            this.progressEl.textContent = this.incentiveText.replace('{count}', remaining);
          }
        }

        if (this.submitButton) {
          this.submitButton.disabled = selectedCount === 0;
        }
      }

      onSubmit() {
        const variantIds = this.selectedVariantIds;
        if (variantIds.length === 0 || !this.addUrl) return;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const config = fetchConfig('json');
        const items = variantIds.map((id) => ({ id, quantity: 1 }));
        const body = { items };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(body);

        fetch(this.addUrl, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.description || response.message);
              return;
            }

            if (this.cart) {
              if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.cart.renderContents(response);
            } else {
              window.location = window.routes ? window.routes.cart_url : '/cart';
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
